import { FC } from 'react';

import {
  BreadCrumbsContainer,
  CrumbLink,
  CrumbSeperator,
} from '~src/modules/reports/reportsHeader/containers/ReportsHeader.sc';
import { BreadCrumb } from '~src/modules/reports/interfaces/header.interface';

interface Props {
  smallHeader: boolean;
  breadCrumbLinks: BreadCrumb[];
}

const BreadCrumbs: FC<Props> = (props) => (
  <BreadCrumbsContainer $smallHeader={props.smallHeader}>
    {props.breadCrumbLinks.map((breadCrumb, index) => (
      <span key={breadCrumb.name}>
        <CrumbSeperator>{index !== 0 ? '»' : null}</CrumbSeperator>
        <CrumbLink key={breadCrumb.name} to={breadCrumb.link}>
          {breadCrumb.name}
        </CrumbLink>
      </span>
    ))}
  </BreadCrumbsContainer>
);

export default BreadCrumbs;
